import * as React from 'react';
import { OnIgnoreEnter } from '../AnalyseApp';
import { faVolumeHigh, faVolumeOff } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface ChannelToggleProps {
    name: string;
    isMuted: boolean;
    onToggleMuteClick: () => void;
}

export const ChannelToggle = (props: ChannelToggleProps) => {
    if (props.isMuted) {
        return (
            <button id={"Mute" + props.name} className="btn btn-danger" onClick={(e: any) => { e.target.blur(); props.onToggleMuteClick() }} onKeyDown={OnIgnoreEnter}><FontAwesomeIcon icon={faVolumeOff} className="fa-fw" aria-hidden="true" />&nbsp;{props.name}</button>
        );
    } else {
        return (
            <button id={"Mute" + props.name} className="btn btn-primary" onClick={(e: any) => { e.target.blur(); props.onToggleMuteClick() }} onKeyDown={OnIgnoreEnter}><FontAwesomeIcon icon={faVolumeHigh} className="fa-fw" aria-hidden="true" />&nbsp;{props.name}</button>
        );
    }
}
